import { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Badge,
  Box,
  Chip,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Organization } from "src/complaint/types";
import { useTranslation } from "react-i18next";

type TProps = {
  organizations: Organization[] | undefined;
};

function SupervisoryOrganizations({ organizations }: TProps) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  if (!organizations?.length) return null;

  return (
    <Accordion
      expanded={expanded}
      onChange={(_, isExpanded) => setExpanded(isExpanded)}
      sx={{
        backgroundColor: "rgba(25, 118, 210, 0.08)",
        boxShadow: "none",
        borderRadius: "8px !important",
        "&:before": { display: "none" },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          "& .MuiAccordionSummary-content": {
            flexDirection: "column",
            overflow: "hidden",
          },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
          <Typography variant="subtitle1" fontWeight="bold">
            {t("Υ.Γ.Ε.ΜΗ. που σας έχουν ανατεθεί για εποπτεία:")}
          </Typography>
          <Badge
            badgeContent={organizations.length}
            color="warning"
            sx={{ "& .MuiBadge-badge": { position: "static", transform: "none" } }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
            maxHeight: expanded ? "none" : "28px",
            overflow: "hidden",
            transition: "max-height 0.3s ease",
          }}
        >
          {organizations.map((org) => (
            <Chip
              key={org.id}
              label={org.label}
              size="small"
              sx={(theme) => ({
                backgroundColor: theme.palette.primary.main,
                color: "#fff",
              })}
            />
          ))}
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }} />
    </Accordion>
  );
}

export default SupervisoryOrganizations;
